(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["fika-bundle"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fika-bundle')) {
    customElements.define('fika-bundle', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.config = JSON.parse(this.querySelector('[data-bundle-config]').textContent);
        this.dialog = this.querySelector('dialog');
        this.target = 3;
        this.abort = new AbortController();
        this.eligibleIds = new Set(this.config.products.map(p => p.id));
        this.variantIds = new Set([47625894461669,47625894494437,47625894527205,47625894559973,49262439727333,49262439760101,49262439792869]);
        this.money = value => new Intl.NumberFormat(this.config.locale, {style:'currency', currency:this.config.currency}).format(value / 100);
        this.buildCatalog();
        this.addEventListener('click', event => {
          const tier = event.target.closest('[data-target]');
          if (tier) { this.target = Number(tier.dataset.target); this.querySelectorAll('[data-target]').forEach(button => button.setAttribute('aria-pressed', String(button === tier))); if (this.target > 1) this.openPicker(); }
          if (event.target.closest('[data-open]')) this.openPicker();
          if (event.target.closest('[data-close]')) this.dialog.close();
        }, {signal:this.abort.signal, capture:true});
        document.addEventListener('cart:update', this.cartListener = async event => {
          if (event.detail?.data?.didError) return;
          await this.refresh();
          if (event.detail?.data?.source === 'product-form-component' && this.eligibleIds.has(Number(event.detail.data.productId)) && this.count < 3) this.openPicker();
        }, {signal:this.abort.signal});
        this.refresh();
      }
      disconnectedCallback() { this.abort?.abort(); this.ready = false; }
      async request(path, options = {}) {
        const response = await fetch((window.Shopify?.routes?.root || '/') + path, {...options, headers:{'Content-Type':'application/json', ...options.headers}});
        const data = await response.json();
        if (!response.ok || data.status) throw new Error(data.description || data.message || this.config.text.error);
        return data;
      }
      async refresh() {
        try {
          const cart = await this.request('cart.js');
          this.items = cart.items.filter(item => this.variantIds.has(Number(item.variant_id)) && item.original_price === 4800);
          this.count = this.items.reduce((count,item) => count + item.quantity,0);
          const message = this.count === 0 ? this.config.text.start : this.count === 1 ? this.config.text.one : this.count === 2 ? this.config.text.two : this.config.text.complete;
          this.querySelector('.fika-bundle__progress').textContent = message;
          this.querySelector('[data-dialog-progress]').textContent = message;
          const bar = this.querySelector('[role=progressbar]');
          bar.setAttribute('aria-valuenow', String(Math.min(this.count,3)));
          bar.firstElementChild.style.width = Math.min(this.count / 3 * 100,100) + '%';
          this.querySelector('[data-offer]').textContent = this.money(this.target === 1 ? 4800 : this.target === 2 ? this.config.twoPrice : this.config.threePrice);
          const selected = this.querySelector('.fika-bundle__selected'); selected.replaceChildren();
          for (const item of this.items) {
            const row = document.createElement('div'); const img = document.createElement('img'); img.src = item.image; img.alt = ''; const label = document.createElement('span'); label.textContent = item.product_title + ' · ' + item.variant_title + ' × ' + item.quantity; const remove = document.createElement('button'); remove.type='button'; remove.textContent=this.config.text.remove;
            remove.addEventListener('click', () => this.mutate('cart/change.js', {id:item.key,quantity:Math.max(0,item.quantity-1)})); row.append(img,label,remove); selected.append(row);
          }
        } catch (error) { this.querySelector('[data-error]').textContent = error.message; }
      }
      buildCatalog() {
        const catalog = this.querySelector('.fika-bundle__catalog'); catalog.replaceChildren();
        for (const product of this.config.products) {
          const available = product.variants.filter(variant => variant.available && this.variantIds.has(Number(variant.id)) && variant.price === 4800); if (!available.length) continue;
          const card = document.createElement('div'); card.className='fika-bundle__card'; const image=document.createElement('img'); image.src=available[0].image; image.alt=product.title; image.loading='lazy'; const title=document.createElement('h4'); title.textContent=product.title; const select=document.createElement('select'); select.setAttribute('aria-label',this.config.text.variant + ' ' + product.title);
          available.forEach(variant => { const option=document.createElement('option'); option.value=String(variant.id); option.textContent=variant.title; select.append(option); });
          select.addEventListener('change',() => { image.src=available.find(variant => String(variant.id) === select.value).image; });
          const button=document.createElement('button'); button.type='button'; button.textContent=this.config.text.add; button.addEventListener('click',() => this.mutate('cart/add.js',{items:[{id:Number(select.value),quantity:1}]})); card.append(image,title,select,button); catalog.append(card);
        }
      }
      async mutate(path,body) {
        if (this.busy) return;
        this.busy=true; this.querySelector('[data-error]').textContent=''; this.querySelectorAll('button').forEach(button=>button.disabled=true);
        try {
          const sections = [...new Set([...document.querySelectorAll('cart-items-component')].map(element => element.dataset.sectionId).filter(Boolean))];
          if (sections.length) body.sections = sections.slice(0,5);
          const response = await this.request(path,{method:'POST',body:JSON.stringify(body)});
          const cart = await this.request('cart.js');
          const drawer = document.querySelector('cart-drawer-component'); const autoOpen = drawer?.hasAttribute('auto-open');
          if (autoOpen) drawer.removeAttribute('auto-open');
          document.dispatchEvent(new CustomEvent('cart:update',{detail:{resource:cart,sourceId:'fika-bundle',data:{source:'fika-bundle',sections:response.sections,itemCount:cart.item_count}}}));
          if (autoOpen) drawer.setAttribute('auto-open','');
          await this.refresh();
        }
        catch(error) { this.querySelector('[data-error]').textContent=error.message; }
        finally { this.busy=false; this.querySelectorAll('button').forEach(button=>button.disabled=false); }
      }
      async openPicker() {
        await this.refresh();
        const nativeDrawer=document.querySelector('cart-drawer-component');
        if (nativeDrawer?.querySelector('dialog')?.open) { nativeDrawer.close(); await new Promise(resolve=>requestAnimationFrame(resolve)); }
        if (!this.dialog.open) this.dialog.showModal();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
